var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Arrow-Right",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 14.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.45,14.5a1.51,1.51,0,0,0,2.15,0h0l6-6a1.52,1.52,0,0,0,0-2.15h0L2.59.44A1.52,1.52,0,1,0,.45,2.59L5.33,7.47.45,12.35a1.52,1.52,0,0,0,0,2.15h0",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.5bc3bd62df40c89bab5095dfdfff8e41.svg";
export { ForwardRef as ReactComponent };